<template>
<div>
    <!-- Top Navigation -->
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-294"></a>
                <div class="form-nav-div">
                    <a href="#" @click.prevent="GoBack()" class="back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Metabolic Report</div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((active_el-1) / totalSteps) * 100) }}% </strong>Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">

                </div>
            </div>
        </div>
    </section>
    <div v-if="isSubmitting" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <section class="afterreport_section">
        <div class="questions-div">
            <div class="question-container" v-if="active_el === 1">
                <div class="question-div-2">
                    <div class="text-block-513 hq">What's your waist size?</div>
                    <div class="form-subs">This helps us understand your body composition and create a more personalized plan.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit" id="email-form" name="email-form" data-name="Email Form" method="get">
                            
                            <!-- Option 1: I know my waist measurement in inches -->
                            <a href="#" @click.prevent="selectWaistOption('measurement')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.waist_type === 'measurement', 'field-error': fieldErrors.waist_type }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_ruler.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Click Here to Enter Your Exact Waist Size</div>
                                        <div class="text-block-850">This will provide a more accurate report</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>

                            <!-- Option 2: I don't know - select clothing size -->
                            <a href="#" @click.prevent="selectWaistOption('clothing_size')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.waist_type === 'clothing_size', 'field-error': fieldErrors.waist_type }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_clothing.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Click Here to Enter Your Pants Size</div>
                                        <div class="text-block-850">Less accurate, but still effective.</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>

                            <!-- Show measurement input if "measurement" option is selected -->
                            <div v-if="quizData.waist_type === 'measurement'" class="measurement-input-section">
                                <div class="div-block-1476">
                                    <div class="input-with-suffix">
                                        <input class="text-field-43 w-input measurement-input" 
                                            :class="{ 'field-error': fieldErrors.waist_measurement }" 
                                            maxlength="10" 
                                            v-model="quizData.waist_measurement" 
                                            name="waist-measurement" 
                                            data-name="Waist Measurement" 
                                            placeholder="e.g., 32" 
                                            type="text" 
                                            id="waist-measurement"
                                            required>
                                        <span class="input-suffix">inches</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Show clothing size dropdown if "clothing_size" option is selected -->
                            <div v-if="quizData.waist_type === 'clothing_size'" class="clothing-size-section">
                                <div class="div-block-1476">
                                    <select class="text-field-43 w-input extendfull" 
                                            :class="{ 'field-error': fieldErrors.clothing_size }" 
                                            v-model="quizData.clothing_size" 
                                            name="clothing-size" 
                                            data-name="Clothing Size" 
                                            id="clothing-size"
                                            required>
                                        <option value="">Select your size</option>
                                        
                                        <!-- Show different options based on user gender -->
                                        <template v-if="user && user.gender === 'Female'">
                                            <!-- Women's dress/pant sizes -->
                                            <option value="XS">XS (0-2)</option>
                                            <option value="S">S (4-6)</option>
                                            <option value="M">M (8-10)</option>
                                            <option value="L">L (12-14)</option>
                                            <option value="XL">XL (16-18)</option>
                                            <option value="XXL">XXL (20-22)</option>
                                            <option value="XXXL">XXXL (24+)</option>
                                            
                                            <!-- Additional women's numeric sizes -->
                                            <optgroup label="Numeric Sizes">
                                                <option value="0">0</option>
                                                <option value="2">2</option>
                                                <option value="4">4</option>
                                                <option value="6">6</option>
                                                <option value="8">8</option>
                                                <option value="10">10</option>
                                                <option value="12">12</option>
                                                <option value="14">14</option>
                                                <option value="16">16</option>
                                                <option value="18">18</option>
                                                <option value="20">20</option>
                                                <option value="22">22</option>
                                                <option value="24">24</option>
                                                <option value="26">26+</option>
                                            </optgroup>
                                        </template>
                                        
                                        <template v-else-if="user && user.gender === 'Male'">
                                            <!-- Men's waist/pant sizes -->
                                            <option value="28">28</option>
                                            <option value="29">29</option>
                                            <option value="30">30</option>
                                            <option value="31">31</option>
                                            <option value="32">32</option>
                                            <option value="33">33</option>
                                            <option value="34">34</option>
                                            <option value="35">35</option>
                                            <option value="36">36</option>
                                            <option value="38">38</option>
                                            <option value="40">40</option>
                                            <option value="42">42</option>
                                            <option value="44">44</option>
                                            <option value="46">46</option>
                                            <option value="48">48+</option>
                                            
                                            <!-- Men's letter sizes -->
                                            <optgroup label="Letter Sizes">
                                                <option value="S">S (28-30)</option>
                                                <option value="M">M (32-34)</option>
                                                <option value="L">L (36-38)</option>
                                                <option value="XL">XL (40-42)</option>
                                                <option value="XXL">XXL (44-46)</option>
                                                <option value="XXXL">XXXL (48+)</option>
                                            </optgroup>
                                        </template>
                                        
                                        <!-- Fallback if gender is not set or other value -->
                                        <template v-else>
                                            <!-- General sizes -->
                                            <optgroup label="Letter Sizes">
                                                <option value="XS">XS</option>
                                                <option value="S">S</option>
                                                <option value="M">M</option>
                                                <option value="L">L</option>
                                                <option value="XL">XL</option>
                                                <option value="XXL">XXL</option>
                                                <option value="XXXL">XXXL</option>
                                            </optgroup>
                                            
                                            <optgroup label="Numeric Sizes">
                                                <option value="28">28</option>
                                                <option value="30">30</option>
                                                <option value="32">32</option>
                                                <option value="34">34</option>
                                                <option value="36">36</option>
                                                <option value="38">38</option>
                                                <option value="40">40</option>
                                                <option value="42">42+</option>
                                            </optgroup>
                                        </template>
                                    </select>
                                </div>
                            </div>
                            
                            <!-- Submit button - only show if an option is selected and filled -->
                            <div v-if="canProceed">
                                <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next ->">
                            </div>
                            
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Question 3: Activity Level -->
            <div class="question-container" v-if="active_el === 2">
                <div class="question-div-2">
                    <div class="text-block-513 hq">What is your activity level?</div>
                    <div class="form-subs">Understanding your current activity helps us tailor recommendations for your lifestyle.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit" id="email-form" name="email-form" data-name="Email Form" method="get">
                            <a href="#" @click.prevent="selectOption('activity_level', 'Sedentary')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.activity_level === 'Sedentary', 'field-error': fieldErrors.activity_level }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Sedentary</div>
                                        <div class="text-block-850">Little or no exercise</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('activity_level', 'Lightly active')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.activity_level === 'Lightly active', 'field-error': fieldErrors.activity_level }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-2.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Lightly Active</div>
                                        <div class="text-block-850">Light exercise/sports 1-2 days per week</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('activity_level', 'Moderately active')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.activity_level === 'Moderately active', 'field-error': fieldErrors.activity_level }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-3.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Moderately Active</div>
                                        <div class="text-block-850">Moderate exercise/sports 3-5 days per week</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('activity_level', 'Very active')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.activity_level === 'Very active', 'field-error': fieldErrors.activity_level }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-4.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Very Active</div>
                                        <div class="text-block-850">Hard exercise/sports 6-7 days per week</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('activity_level', 'Highly active')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.activity_level === 'Highly active', 'field-error': fieldErrors.activity_level }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-5.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Highly Active</div>
                                        <div class="text-block-850">Hard daily exercise/sports & physical job</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Question 4: Daily Steps -->
            <div class="question-container" v-if="active_el === 3">
                <div class="question-div-2">
                    <div class="text-block-513 hq">How many steps do you take daily on average?</div>
                    <div class="form-subs">If you're unsure, estimate based on your typical day. This helps us understand your baseline activity.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit" id="email-form" name="email-form" data-name="Email Form" method="get">
                            <a href="#" @click.prevent="selectOption('daily_steps', '<3k')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_steps === '<3k', 'field-error': fieldErrors.daily_steps }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Less than 3,000</div>
                                        <div class="text-block-850">Mostly desk work, minimal walking</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('daily_steps', '3-6k')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_steps === '3-6k', 'field-error': fieldErrors.daily_steps }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-2.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">3,000 - 6,000</div>
                                        <div class="text-block-850">Some walking, light daily activity</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('daily_steps', '6-9k')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_steps === '6-9k', 'field-error': fieldErrors.daily_steps }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-3.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">6,000 - 9,000</div>
                                        <div class="text-block-850">Regular walking, moderately active</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('daily_steps', '9k+')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_steps === '9k+', 'field-error': fieldErrors.daily_steps }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-4.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">9,000+</div>
                                        <div class="text-block-850">Very active, lots of walking/movement</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Question 5: Weekly Exercise -->
            <div class="question-container" v-if="active_el === 4">
                <div class="question-div-2">
                    <div class="text-block-513 hq">How often do you exercise per week?</div>
                    <div class="form-subs">Include any structured exercise like gym workouts, sports, yoga, or fitness classes.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit" id="email-form" name="email-form" data-name="Email Form" method="get">
                            <a href="#" @click.prevent="selectOption('weekly_exercise', 'None')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.weekly_exercise === 'None', 'field-error': fieldErrors.weekly_exercise }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">None</div>
                                        <div class="text-block-850">No structured exercise</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('weekly_exercise', '1-2x/wk')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.weekly_exercise === '1-2x/wk', 'field-error': fieldErrors.weekly_exercise }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-2.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">1-2 times per week</div>
                                        <div class="text-block-850">Occasional workouts</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('weekly_exercise', '3-4x/wk')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.weekly_exercise === '3-4x/wk', 'field-error': fieldErrors.weekly_exercise }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-3.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">3-4 times per week</div>
                                        <div class="text-block-850">Regular exercise routine</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('weekly_exercise', '5+ days/wk')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.weekly_exercise === '5+ days/wk', 'field-error': fieldErrors.weekly_exercise }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_level-4.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">5+ days per week</div>
                                        <div class="text-block-850">Very dedicated fitness routine</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Question 6: Daily Water Intake -->
            <div class="question-container" v-if="active_el === 5">
                <div class="question-div-2">
                    <div class="text-block-513 hq">How much water do you drink daily?</div>
                    <div class="form-subs">Proper hydration is crucial for weight loss and overall health. Include all water-based beverages.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit" id="email-form" name="email-form" data-name="Email Form" method="get">
                            <a href="#" @click.prevent="selectOption('daily_water', '<40 oz')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_water === '<40 oz', 'field-error': fieldErrors.daily_water }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_water.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Less than 40 oz</div>
                                        <div class="text-block-850">About 2-3 cups per day</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('daily_water', '40-64 oz')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_water === '40-64 oz', 'field-error': fieldErrors.daily_water }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_water-2.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">40-64 oz</div>
                                        <div class="text-block-850">About 3-4 cups per day</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('daily_water', '65-90 oz')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_water === '65-90 oz', 'field-error': fieldErrors.daily_water }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_water-3.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">65-90 oz</div>
                                        <div class="text-block-850">About 4-6 cups per day</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('daily_water', '90+ oz')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.daily_water === '90+ oz', 'field-error': fieldErrors.daily_water }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_water-4.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">90+ oz</div>
                                        <div class="text-block-850">6+ cups per day (recommended)</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Question 7: Sleep Hours -->
            <div class="question-container" v-if="active_el === 6">
                <div class="question-div-2">
                    <div class="text-block-513 hq">How many hours of sleep do you get per night?</div>
                    <div class="form-subs">Sleep quality affects metabolism, hunger hormones, and weight management. Be honest about your average.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit" id="email-form" name="email-form" data-name="Email Form" method="get">
                            <a href="#" @click.prevent="selectOption('sleep_hours', '<6')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.sleep_hours === '<6', 'field-error': fieldErrors.sleep_hours }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_time.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">Less than 6 hours</div>
                                        <div class="text-block-850">Often tired, irregular schedule</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('sleep_hours', '6-7')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.sleep_hours === '6-7', 'field-error': fieldErrors.sleep_hours }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_time-2.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">6-7 hours</div>
                                        <div class="text-block-850">Sometimes tired, busy schedule</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('sleep_hours', '7-8')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.sleep_hours === '7-8', 'field-error': fieldErrors.sleep_hours }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_time-4.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">7-8 hours</div>
                                        <div class="text-block-850">Generally well-rested</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="selectOption('sleep_hours', '8+')" class="link-block-30 w-inline-block" :class="{ 'selected': quizData.sleep_hours === '8+', 'field-error': fieldErrors.sleep_hours }">
                                <div class="div-block-1507">
                                    <img loading="lazy" src="@/assets/images/icon_time-3.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-545">8+ hours</div>
                                        <div class="text-block-850">Consistently well-rested</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- Error Popup -->
    <div class="error_popup" v-if="showErrorPopup">
        <div class="error_box">
            <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Ooops...</div>
            <div class="text-block-1102">{{ errorMessage }}</div>
            <a @click="showErrorPopup = false" href="#" class="button-107 w-button">OK</a>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    name: 'WeightLossQuizExtended',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            active_el: 1, // Start with question 1
            totalSteps: 6, // Total number of questions in this extended quiz
            fieldErrors: {}, // Track individual field errors for better UX
            isSubmitting: false,
            showErrorPopup: false,
            errorMessage: '',
            // Quiz data structure - organized to match the categories mentioned
            quizData: {
                // Body Shape & Clothing Size
                waist_type: '', // 'measurement' or 'clothing_size'
                waist_measurement: '', // For inches input
                clothing_size: '', // For clothing size selection

                // Lifestyle & Activity  
                activity_level: '', // Question 3: Activity level (Sedentary, Lightly active, etc.)
                daily_steps: '', // Question 4: Average daily steps
                weekly_exercise: '', // Question 5: Typical weekly exercise

                // Nutrition & Habits
                daily_water: '', // Question 6: Daily water intake
                sleep_hours: '', // Question 7: Sleep hours per night

                // Will be populated from store
                user_id: null
            }
        }
    },
    async mounted() {
        console.log('Component mounted, active_el:', this.active_el); // Debug log

        // Get user data from store - since we know the user is already logged in via router auth
        if (this.user && this.user.id) {
            this.quizData.user_id = this.user.id;
            console.log('User found:', this.user.id); // Debug log
        } else {
            console.log('No user found in store:', this.user); // Debug log
            // Since router auth is handled, we can still continue but log the issue
            console.warn('User not found in store, but continuing due to router auth');
        }
    },
    computed: {
        ...mapGetters(['user']), // Get current user from Vuex store
        canProceed() {
            if (this.quizData.waist_type === 'measurement') {
                return this.quizData.waist_measurement && this.quizData.waist_measurement.trim() !== '';
            } else if (this.quizData.waist_type === 'clothing_size') {
                return this.quizData.clothing_size && this.quizData.clothing_size !== '';
            }
            return false;
        }
    },
    methods: {
        ...mapActions(['updateUserQuizData']), // Action to update user data in store

        selectWaistOption(optionType) {
        this.quizData.waist_type = optionType;
        
        // Clear the other option's data when switching to prevent conflicts
        if (optionType === 'measurement') {
            this.quizData.clothing_size = '';
            this.clearFieldError('clothing_size');
        } else {
            this.quizData.waist_measurement = '';
            this.clearFieldError('waist_measurement');
        }
        
        this.clearFieldError('waist_type');
    },
    isValidWaistMeasurement(measurement) {
        if (!measurement || measurement.trim() === '') {
            return false;
        }
        
        const numericValue = measurement.replace(/[^\d.]/g, '');
        const parsedValue = parseFloat(numericValue);
        
        return !isNaN(parsedValue) && parsedValue >= 20 && parsedValue <= 60;
    },

    validateWaistSize() {
        this.fieldErrors = {};
        
        if (!this.quizData.waist_type) {
            this.setFieldError('waist_type');
            this.showError('Please select how you want to provide your waist information');
            return false;
        }
        
        if (this.quizData.waist_type === 'measurement') {
            if (!this.isValidWaistMeasurement(this.quizData.waist_measurement)) {
                this.setFieldError('waist_measurement');
                this.showError('Please enter a valid waist measurement (20-60 inches)');
                return false;
            }
        } else if (this.quizData.waist_type === 'clothing_size') {
            if (!this.quizData.clothing_size) {
                this.setFieldError('clothing_size');
                this.showError('Please select your clothing size');
                return false;
            }
        }
        
        return true;
    },
        // Clear field errors when user starts selecting options
        clearFieldError(field) {
            if (this.fieldErrors[field]) {
                this.$set(this.fieldErrors, field, false);
            }
        },

        // Set field error for validation feedback
        setFieldError(field, hasError = true) {
            this.$set(this.fieldErrors, field, hasError);
        },

        // Navigate back to previous question
        GoBack() {
            if (this.active_el > 1) {
                this.active_el--;
                // Clear field errors when going back for better UX
                this.fieldErrors = {};
            } else {
                // If at first question, go back to previous component
                this.$router.push('/home');
            }
        },

        // Handle selection for multiple choice questions (questions 3-7)
        selectOption(field, value) {
            this.quizData[field] = value;
            this.clearFieldError(field);
            // Auto-advance to next question after selection for better UX
            this.handleSubmit();
        },

        // Show error popup with custom message
        showError(message) {
            this.errorMessage = message;
            this.showErrorPopup = true;
        },

        // Validate waist size input - should be reasonable number or jean size
        isValidWaistSize(waistSize) {
            if (!waistSize || waistSize.trim() === '') {
                return false;
            }

            // Remove any non-numeric characters except decimal point
            const numericValue = waistSize.replace(/[^\d.]/g, '');
            const parsedValue = parseFloat(numericValue);

            // Check if it's a reasonable waist measurement (20-60 inches) or jean size (24-60)
            if (isNaN(parsedValue) || parsedValue < 20 || parsedValue > 60) {
                return false;
            }

            return true;
        },

        // Validate pant/dress size - should be alphanumeric and reasonable
        isValidClothingSize(size) {
            if (!size || size.trim() === '') {
                return false;
            }

            // Allow alphanumeric sizes like "32", "M", "14", "XL", etc.
            const sizeRegex = /^[0-9]+[A-Z]*$|^[XS|S|M|L|XL|XXL|XXXL]+$/i;
            return sizeRegex.test(size.trim());
        },

        // Comprehensive validation for each step
        validateStep(step) {
        this.fieldErrors = {}; // Clear all previous field errors

        switch (step) {
            case 1: // Combined Waist Size (replaces both waist_size and pant_dress_size)
                return this.validateWaistSize();
                
            // case 2 is now removed since we combined the questions
            
            case 2: // Activity Level (previously case 3)
                if (!this.quizData.activity_level) {
                    this.setFieldError('activity_level');
                    this.showError('Please select your activity level');
                    return false;
                }
                break;

            case 3: // Daily Steps (previously case 4)
                if (!this.quizData.daily_steps) {
                    this.setFieldError('daily_steps');
                    this.showError('Please select your average daily steps');
                    return false;
                }
                break;

            case 4: // Weekly Exercise (previously case 5)
                if (!this.quizData.weekly_exercise) {
                    this.setFieldError('weekly_exercise');
                    this.showError('Please select your weekly exercise frequency');
                    return false;
                }
                break;

            case 5: // Daily Water (previously case 6)
                if (!this.quizData.daily_water) {
                    this.setFieldError('daily_water');
                    this.showError('Please select your daily water intake');
                    return false;
                }
                break;

            case 6: // Sleep Hours (previously case 7)
                if (!this.quizData.sleep_hours) {
                    this.setFieldError('sleep_hours');
                    this.showError('Please select your average sleep hours');
                    return false;
                }
                break;
        }

        return true;
    },

        // Handle form submission for each step
        async handleSubmit() {
            if (!this.validateStep(this.active_el)) {
                return;
            }

            // If not at last step, just move to next question
            if (this.active_el < this.totalSteps) {
                this.active_el++;
                return;
            }

            // If at last step, submit the complete quiz data
            await this.finalSubmit();
        },

        // Submit the complete quiz data to backend
        async finalSubmit() {
            if (!this.validateStep(this.active_el)) {
                return;
            }

            try {
                this.isSubmitting = true;

                // Prepare the data payload with user ID
                const payload = {
                    ...this.quizData,
                    user_id: this.user.id,
                    quiz_completed_at: new Date().toISOString()
                };

                // Submit quiz data to backend API
                const response = await this.$axios.post(`${this.baseUrl}/api/user-quiz-extended`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });

                if (response.data.status === 'success') {
                    this.$router.push({
                        name: 'reportTdee',
                        query: {
                            'completed': 'extended-quiz'
                        }
                    });
                } else {
                    throw new Error(response.data.message || 'Quiz submission failed');
                }
            } catch (error) {
                console.error('Quiz submission error:', error);
                this.showError('There was an error submitting your quiz. Please try again.');
            } finally {
                this.isSubmitting = false;
            }
        }
    },

    watch: {
        // Auto-scroll to top when question changes for better UX
        active_el() {
            window.scrollTo(0, 0);
        },

        // Watch for changes in form fields to clear errors in real-time
        'quizData.waist_size'() {
            this.clearFieldError('waist_size');
        },
        'quizData.pant_dress_size'() {
            this.clearFieldError('pant_dress_size');
        },
        'quizData.activity_level'() {
            this.clearFieldError('activity_level');
        },
        'quizData.daily_steps'() {
            this.clearFieldError('daily_steps');
        },
        'quizData.weekly_exercise'() {
            this.clearFieldError('weekly_exercise');
        },
        'quizData.daily_water'() {
            this.clearFieldError('daily_water');
        },
        'quizData.sleep_hours'() {
            this.clearFieldError('sleep_hours');
        }
    }
}
</script>

<style scoped>
.text-block-545 {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
}

/* Responsive design for mobile devices */
@media screen and (max-width: 479px) {
    .text-block-513.hq {
        text-align: left;
        width: 100%;
        font-size: 28px;
    }

    .form-subs {
        font-size: 14px;
        margin-bottom: 20px;
    }
}

/* Field error styling - matches original component */
.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

/* Input field error styling */
input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Selection link error styling for multiple choice questions */
.link-block-30.field-error {
    border: 2px solid #dc3545 !important;
    background-color: rgba(220, 53, 69, 0.05) !important;
}

/* Focus states for error fields */
input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Selected state styling for multiple choice options */
.link-block-30.selected {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
    color: white !important;
}

.link-block-30.selected .text-block-545,
.link-block-30.selected .text-block-850,
.link-block-30.selected .text-block-546 {
    color: white !important;
}

/* Ensure error styling takes precedence */
.w-input.field-error {
    border: 2px solid #dc3545 !important;
}

/* Loading button styling */
.form-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Better styling for option layout with icons */
.div-block-1507 {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.image-313 {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.div-block-1507>div {
    flex: 1;
}

.extendfull {
    width: 100%;
}

/* Better spacing for mobile */
@media screen and (max-width: 767px) {
    .link-block-30 {
        margin-bottom: 12px;
    }

    .question-div-2 {
        padding: 20px;
    }

    .form-subs {
        font-size: 15px;
        line-height: 1.4;
    }
}
/* Styling for the measurement input section */
.measurement-input-section {
    margin-top: 20px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 2px solid #e9ecef;
    animation: fadeIn 0.3s ease-in;
}

.clothing-size-section {
    margin-top: 20px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 2px solid #e9ecef;
    animation: fadeIn 0.3s ease-in;
}

/* Fade in animation for better UX */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Input with suffix styling */
.input-with-suffix {
    position: relative;
    display: flex;
    align-items: center;
}

.measurement-input {
    flex: 1;
    padding-right: 60px !important; /* Make room for suffix */
}

.input-suffix {
    position: absolute;
    right: 15px;
    color: #666;
    font-weight: 500;
    pointer-events: none;
    font-size: 14px;
}

/* Enhanced styling for selected options */
.link-block-30.selected {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
    color: white !important;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
    transition: all 0.3s ease;
}

.link-block-30.selected .text-block-545,
.link-block-30.selected .text-block-850,
.link-block-30.selected .text-block-546 {
    color: white !important;
}

/* Hover effects for better UX */
.link-block-30:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
}

.link-block-30:active {
    transform: translateY(0);
}

/* Error state styling */
.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

.measurement-input-section.field-error,
.clothing-size-section.field-error {
    border-color: #dc3545;
    background-color: rgba(220, 53, 69, 0.05);
}

/* Input field error styling */
input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Selection link error styling for multiple choice questions */
.link-block-30.field-error {
    border: 2px solid #dc3545 !important;
    background-color: rgba(220, 53, 69, 0.05) !important;
}

/* Focus states for error fields */
input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Better styling for dropdown */
.clothing-select {
    appearance: none;
    background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="%23666" d="M2 0L0 2h4zm0 5L0 3h4z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 12px;
    padding-right: 40px;
}

/* Mobile responsiveness */
@media screen and (max-width: 767px) {
    .measurement-input-section,
    .clothing-size-section {
        margin-top: 15px;
        padding: 15px;
    }
    
    .input-suffix {
        right: 12px;
        font-size: 12px;
    }
    
    .measurement-input {
        padding-right: 55px !important;
    }
    
    .link-block-30 {
        margin-bottom: 12px;
    }
    
    .text-block-545 {
        font-size: 16px;
    }
    
    .text-block-850 {
        font-size: 14px;
    }
}

@media screen and (max-width: 479px) {
    .measurement-input-section,
    .clothing-size-section {
        padding: 12px;
        margin-top: 12px;
    }
    
    .input-suffix {
        font-size: 11px;
        right: 10px;
    }
    
    .measurement-input {
        padding-right: 50px !important;
        font-size: 16px; /* Prevent zoom on iOS */
    }
    
    .clothing-select {
        font-size: 16px; /* Prevent zoom on iOS */
    }
    .questions-div {
        width: 100%;
        padding-left: 0%; 
        padding-right: 0%; 
    }
}

/* Ensure the existing styles still work */
.extendfull {
    width: 100%;
}

.text-block-545 {
    text-align: left; 
}

.w-input.field-error {
    border: 2px solid #dc3545 !important;
}

/* Loading button styling */
.form-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Better styling for option layout with icons */
.div-block-1507 {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.image-313 {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.div-block-1507 > div {
    flex: 1;
}
</style>
